var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoupeDefault = function SvgCoupeDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.8,
    d: "M13.606 13.854a.885.885 0 1 1-1.77 0 .885.885 0 0 1 1.77 0ZM37.545 13.854a.885.885 0 1 1-1.77 0 .885.885 0 0 1 1.77 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.774,
    d: "M30.327 6.712c-2.45-1.65-7.117-1.984-9.536-2.059a.76.76 0 0 0-.734 1.024l.56 1.57a.76.76 0 0 0 .697.507c2.012.043 6.26.006 8.595-.01.629-.004.94-.681.418-1.032ZM18.764 5.585l.397 1.107a.777.777 0 0 1-.737 1.038c-1.33-.007-2.545-.002-3.422.003-.595.003-.923-.618-.467-1 .798-.67 1.914-1.166 3.276-1.618a.76.76 0 0 1 .953.47Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeLinecap: "round",
    strokeWidth: 0.774,
    d: "m10.267 14.286-4.24-1.553a.3.3 0 0 1-.082-.05v0a2.52 2.52 0 0 1-.453-3.223l.095-.152a.3.3 0 0 0 .04-.113l.287-2.379a.76.76 0 0 1 .616-.658c1.392-.251 3.753-.653 7.8-2.155 1.733-.585 10.155-3.396 20.332 2.78.07.042.15.075.23.094 2.418.559 4.26.828 7.798 2.274.096.04.184.098.247.18.34.437 1.263 1.936.233 3.844a.71.71 0 0 1-.488.352l-3.654.759m-23.835 0h18.892"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.774,
    d: "M15.05 13.854a2.33 2.33 0 1 1-4.661 0 2.33 2.33 0 0 1 4.662 0ZM38.99 13.854a2.33 2.33 0 1 1-4.662 0 2.33 2.33 0 0 1 4.662 0Z"
  })));
};
export default SvgCoupeDefault;